import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { reverbUrl } from ".";

//@ts-ignore
window.Pusher = Pusher;

const echo = new Echo({
    broadcaster: "pusher",
    key: "vzjaoruz3gbcgszvyqrt",
    wsHost: reverbUrl,
    wsPort: process.env.REACT_APP_ENV === "development" ? 8080 : 443,
    wssPort: process.env.REACT_APP_ENV === "development" ? 8080 : 443,
    forceTLS: true,
    enabledTransports: ["ws", "wss"],
    encrypted: true,
});

//@ts-ignore
window.Echo = echo;

export default echo;
